export default "__VITE_ASSET__BJLOvKsf__"